/**
 * Mailchimp Integration Module (Story 12.1)
 *
 * Barrel export for all Mailchimp OAuth, discovery, error, and adapter modules.
 * Single platform: mailchimp (simpler than Meta/LinkedIn multi-platform).
 *
 * Key simplifications vs other providers:
 * - No scopes (full access)
 * - No PKCE (server-side client_secret)
 * - No refresh tokens (permanent access tokens)
 * - No token-refresh module needed
 */

import { registerAdapter } from "../registry";
import { mailchimpAdapter } from "./mailchimp";

// Register Mailchimp adapter (Story 12.1)
registerAdapter("mailchimp", mailchimpAdapter);

// Platform values (shared constant for frontend/backend alignment)
export const MAILCHIMP_PLATFORM_VALUES = ["mailchimp"] as const;
export type MailchimpPlatform = (typeof MAILCHIMP_PLATFORM_VALUES)[number];

// OAuth utilities
export {
  buildMailchimpAuthUrl,
  exchangeMailchimpCode,
  fetchMailchimpMetadata,
  parseMailchimpCallbackError,
  type MailchimpAuthUrlOptions,
  type MailchimpTokenResponse,
  type MailchimpMetadata,
  type MailchimpCallbackError,
} from "./oauth";

// Account & Audience Discovery
export {
  fetchMailchimpAccountInfo,
  fetchMailchimpAudiences,
  buildMailchimpApiBaseUrl,
  type MailchimpAccountInfo,
  type MailchimpAudience,
} from "./discovery";

// Error parsing
export {
  parseMailchimpApiError,
  type MailchimpApiError,
  type MailchimpErrorType,
} from "./errors";

// Mailchimp Adapter (Story 12.1)
export {
  mailchimpAdapter,
  MAILCHIMP_METRICS,
  MAILCHIMP_DIMENSIONS,
} from "./mailchimp";
